import { render, staticRenderFns } from "./WorkArticle.vue?vue&type=template&id=1e82b0f0&scoped=true&"
import script from "./WorkArticle.vue?vue&type=script&lang=js&"
export * from "./WorkArticle.vue?vue&type=script&lang=js&"
import style0 from "./WorkArticle.vue?vue&type=style&index=0&id=1e82b0f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e82b0f0",
  null
  
)

export default component.exports